<template>
  <div class="overflow-auto  flex-grow">
    <table class="whitespace-nowrap w-full">
      <thead>
        <tr class="w-full">
          <th v-for="(field, key) in fields" 
              :key="key"                   
              class=" border-b border-gray-200 py-2"
              :class="field.thClass"
              :style="{textAlign: field.labelAlign || 'left' }"
              @click="field.sortable ? sortTable(key) : null">
              <div v-if="field.showLabel" class="text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                  {{ field.label }}
              </div>              
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in sortedDataRows" :key="row.id" class="hover:bg-gray-50 rounded-lg cursor-pointer" :class="(searchSelected(row.id)) ? 'isSelected' : 'hover:bg-gray-50' "  @click="$emit('open:item', $event, row)">
          <td v-for="(field, key) in fields" :key="key" class="py-2" :class="field.tdClass">
            <div v-if="field.type === 'multiple'"  :class="field.contentClass" class="whitespace-normal">
                <div v-for="subfield in field.fields" :key="subfield" :class="subfield.divClass">
                    {{ formatField(row[subfield.field], field.type) }}
                </div>
            </div>
            <div v-else-if="field.type === 'image'" class="text-sm flex items-center justify-center ">
                <img :src="row[key] || '/imgs/product.png'" alt="" class="h-16 w-16 object-contain rounded-lg">
            </div>
            <div v-else-if="field.type === 'status'" class="flex items-center justify-center" v-html="formatField(row[key], field.type)"></div>                
            <div v-else class="flex whitespace-normal" :class="field.contentClass">
                {{ formatField(row[key], field.type) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {

  name: 'DataRowsTable',

  props: ['fields', 'dataRows', 'reorder', 'selected'],

  data() {
    return {
      sortKey: '',
      sortAsc: true,
    }
  },

  computed: {
    sortedDataRows() {
      if (!this.sortKey) return this.dataRows;

      return [...this.dataRows].sort((a, b) => {
        if (a[this.sortKey] < b[this.sortKey]) return this.sortAsc ? -1 : 1;
        if (a[this.sortKey] > b[this.sortKey]) return this.sortAsc ? 1 : -1;
        return 0;
      });
    }
  },

  emits: ['open:item', 'open:item_area'],

  methods: {
    sortTable(key) {
        if (key === this.sortKey) {
          this.sortAsc = !this.sortAsc;
        } else {
          this.sortKey = key;
          this.sortAsc = true;
        }
    },

    searchSelected(id) {        
        return this.selected.indexOf(id) > -1;
    },

    formatField(value, type) {

      if (type === 'boolean') {
          return value ? 'Sim' : 'Não';
      }

      if (typeof value === 'object' &&  value !== null) {
          return value.name
      }

      if (type === 'date') {
          const date = new Date(Date.parse(value));
          return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
      }

      if (type === 'status') {
          if(value === 'active') {
              return `<span class="text-green-500">●</span>`;
          } else if(value === 'inative' ) {
              return `<span class="text-rose-500">●</span>`;
          } else {
              return `<span class="text-gray-500">●</span>`;
          }
      }

      if (typeof value === 'string' && value.length > 160) { return value.slice(0, 160) + "..."; }
      if (type === 'multiple') {}
      return value;
    }
  },
};
</script>


<style scoped>
.isSelected {
    @apply bg-indigo-600 text-white;
}

</style>